/**
 * Place for common shared error messages.
 *
 * @type {Object}
 */
export const ERROR_MESSAGES = {
  GENERIC_ERROR_MESSAGE: 'Oops! There was an unknown error. Please refresh the page and try again.'
};
